import { create } from 'zustand'
import { getInitialMeta } from '../config/entityConfigs'

const stores = {}

export const useContentMetaStore = (entityType) => {
  if (!stores[entityType]) {
    const initialMeta = getInitialMeta(entityType)

    stores[entityType] = create((set) => ({
      meta: initialMeta,

      saveHandler: null,
      saveDraftHandler: null,
      publishHandler: null,
      discardDraftHandler: null,
      isSaving: false,
      isPublishing: false,
      isDiscarding: false,

      setMeta: (meta) => set({ meta }),

      updateField: (field, value) =>
        set((state) => ({
          meta: { ...state.meta, [field]: value },
        })),

      resetMeta: () =>
        set({
          meta: initialMeta,
        }),

      setSaveHandler: (handler) => set({ saveHandler: handler }),
      setSaveDraftHandler: (handler) => set({ saveDraftHandler: handler }),
      setPublishHandler: (handler) => set({ publishHandler: handler }),
      setDiscardDraftHandler: (handler) =>
        set({ discardDraftHandler: handler }),
      setIsSaving: (isSaving) => set({ isSaving }),
      setIsPublishing: (isPublishing) => set({ isPublishing }),
      setIsDiscarding: (isDiscarding) => set({ isDiscarding }),
    }))
  }

  return stores[entityType]
}

export default useContentMetaStore
